export default __webpack_public_path__ + "static/media/invoice_5.4eca98d3.png";